import { type YDatabase } from '@databases/collab/y-database';
import { type YEntry } from '@databases/collab/y-entry';
import { err, ok, type Result } from 'neverthrow';

import { type SdkError } from '../../types';

/**
 * Ensures an entry exists before a mutation references it. Returns
 * `STATE_ERROR('ENTRY_NOT_FOUND')` when the id is absent; otherwise the
 * resolved `YEntry` so downstream callers avoid a redundant lookup.
 */
export function assertEntryExists(
  ydb: YDatabase,
  entryId: string
): Result<YEntry, SdkError> {
  const entry = ydb.entriesById[entryId];

  if (!entry) {
    return err({
      type: 'STATE_ERROR',
      reason: 'ENTRY_NOT_FOUND',
      message: `Entry '${entryId}' does not exist`
    });
  }

  return ok(entry);
}
